module.exports = __webpack_public_path__ + "static/media/chilling.41dfe5c5.svg";